import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Typography } from 'src/lib/components/Typography';
import { AuthThemeProvider } from './Auth/AuthThemeProvider';
import Container from './Auth/components/Container';

const DetailList = styled('div')(({ theme }) => ({
    borderTop: `1px solid ${theme.resqPalette.border.subdued}`,
    display: 'grid',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(3),
}));

const Footer = styled('footer')(({ theme }) => ({
    borderTop: `1px solid ${theme.resqPalette.border.subdued}`,
    bottom: 0,
    left: 0,
    padding: theme.spacing(2),
    position: 'fixed',
    right: 0,
    textAlign: 'center',
    backgroundColor: theme.resqPalette.surface.hovered,
}));

export const MaintenancePage = () => {
    const { t } = useTranslation('maintenance');

    return (
        <AuthThemeProvider>
            <Container width={460}>
                <Box textAlign="center">
                    <Typography role="heading1" component="h1" sx={{ mb: 2 }}>
                        {t('title')}
                    </Typography>
                    <Typography role="body" color="subdued" sx={{ mb: 1 }}>
                        {t('body')}
                    </Typography>
                    <Typography role="body" color="subdued">
                        {t('retry')}
                    </Typography>
                </Box>
                <DetailList>
                    <Typography role="body-small-bold">{t('whatIsHappeningTitle')}</Typography>
                    <Typography role="body-small" color="subdued">
                        {t('whatIsHappeningBody')}
                    </Typography>
                </DetailList>
            </Container>
            <Footer>
                <Typography role="body-small" color="subdued">
                    {t('support')}
                </Typography>
            </Footer>
        </AuthThemeProvider>
    );
};
